// extracted by mini-css-extract-plugin
module.exports = {"flexbox":"styles_flexbox__1u7Se"};